import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, BookOpen, Check, Eye, Smile } from 'lucide-react';
const items = [{
  text: 'quieres mejorar tu rutina de cuidado personal',
  icon: Heart
}, {
  text: 'buscas hábitos simples y fáciles de mantener',
  icon: Check
}, {
  text: 'deseas una guía práctica en español',
  icon: BookOpen
}, {
  text: 'te gusta sentirte organizada con tu bienestar',
  icon: Sparkles
}, {
  text: 'prefieres recursos claros, visuales y directos',
  icon: Eye
}, {
  text: 'quieres incorporar más atención y confort en tu día a día',
  icon: Smile
}];
export function ForWhom() {
  return <section className="py-24 bg-white" data-id="element-112">
      <div className="max-w-6xl mx-auto px-6" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-115">
            Esta guía es ideal para ti si:
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto" data-id="element-116" />
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-117">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center p-8 bg-cream border border-bronze/10 hover:border-bronze/30 transition-colors duration-300" data-id="element-118">
              <item.icon className="w-8 h-8 text-bronze mb-6" strokeWidth={1.5} data-id="element-119" />
              <p className="text-charcoal-light font-medium leading-relaxed" data-id="element-120">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}